import { RefObject, useEffect, useRef } from "react";
import "./QuoteWithImageBlock.scss";
import { QuoteWithImageBlockProps } from "/Models/Generated/QuoteWithImageBlockProps";
import {
  Picture,
  InfoSmallIcon,
  ArrowsOutSimple,
} from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";
import { useModal } from "/Components/Shared/ModalProvider/ModalProvider";
import FillViewportKeepAspectRatio from "/Helpers/FillViewportKeepAspectRatio";

interface Props extends QuoteWithImageBlockProps {
  insideModal?: boolean;
  source?: RefObject<HTMLDivElement | null>;
}

const QuoteWithImageBlock = (props: Props) => {
  const {
    hideLine,
    image,
    credits,
    quote,
    quoteBy,
    titleOrCompany,
    insideModal,
    source,
    creditsLabel = "Foto:",
    zoomButtonAriaLabel = "Gjør større",
  } = props;
  const { openModal } = useModal();
  const thisRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!insideModal || !thisRef.current || !source?.current) return;
    const adjustWidth = () => {
      FillViewportKeepAspectRatio(62, 40, thisRef, source);
    };
    adjustWidth();

    window.addEventListener("resize", adjustWidth);
    return () => window.removeEventListener("resize", adjustWidth);
  }, []);

  const bem = createSpreadableBem("quote-with-image-block-norad");

  return (
    <div {...bem("", { "--inside-modal": insideModal })} ref={thisRef}>
      {image && (
        <div {...bem("__thumbnail")}>
          <Picture
            {...image}
            pictureAspectRatio="4/5"
            pictureBehaviour="Cover"
          />
        </div>
      )}
      {quote && (
        <div {...bem("__text-content")}>
          <div {...bem("__quote-container")}>
            <blockquote>
              {!hideLine && <span {...bem("__line")}></span>}
              <span>{quote}</span>
            </blockquote>
            {quoteBy && <div {...bem("__quote-by")}>{quoteBy}</div>}
            {titleOrCompany && (
              <div {...bem("__titleOrCompany")}>{titleOrCompany}</div>
            )}
          </div>
          {credits && (
            <div {...bem("__credits")}>
              <InfoSmallIcon
                hideIconOnMobile
                text={`${creditsLabel.trim()} ${credits}`}
              />
            </div>
          )}

          {!insideModal && image && (
            <button
              {...bem("__zoom")}
              aria-label={zoomButtonAriaLabel}
              onClick={() =>
                openModal(
                  <div {...bem("__modal-wrapper")}>
                    <QuoteWithImageBlock
                      {...props}
                      insideModal
                      source={thisRef}
                      image={image}
                    />
                  </div>
                )
              }
            >
              <span>
                <ArrowsOutSimple size="20" thickness="Reg" />
              </span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default QuoteWithImageBlock;
